import { MiniReact } from "../index"

/** @jsx MiniReact.createElement */
const Footer = () => {
    return (
        <footer className="footer">
            <p>To learn more please click：<a href="https://github.com/codeshihaoran/MiniReact">github</a></p>
            <p>&copy; 2024 Shr</p>
        </footer>
    )
}
export default Footer